export type TriageStatus = "accepted" | "declined" | "duplicate";

export type DeclineReason =
	| "not_relevant"
	| "already_addressed"
	| "scope_issue"
	| "other";

export const DECLINE_REASON_LABELS: Record<DeclineReason, string> = {
	not_relevant: "Not relevant to evaluation",
	already_addressed: "Already addressed in submission",
	scope_issue: "Scope issue — outside evaluation criteria",
	other: "Other",
};

export const TRIAGE_STATUS_LABELS: Record<TriageStatus, string> = {
	accepted: "Accepted",
	declined: "Declined",
	duplicate: "Duplicate",
};


export interface ReviewClarificationCreatedBy {
	id: number;
	name: string;
	company_name?: string;
	email: string;
}

export interface ReviewClarification {
	id: number;
	clarification_impact_id?: number;
	clarification_text: string;
	clarification_type_id: number;
	clarification_type_name?: string;
	created_at: string;
	created_by: ReviewClarificationCreatedBy | null;
	decline_reason: string | null;
	decline_reason_category: DeclineReason | null;
	duplicate_of_id: number | null;
	edited_at: string | null;
	edited_by_name: string | null;
	edited_by_user: number | null;
	impact_label?: string;
	is_approved: boolean | null;
	original_clarification_text: string | null;
	reference_number: number;
	relates_to: string | null;
	reviewed_at: string | null;
	reviewed_by_name: string | null;
	reviewed_by_user: number | null;
	rfx_invite_id: number;
	source_clarification_id: number | null;
	supplier_name: string;
	triage_status: TriageStatus | null;
	updated_at: string;
}

export interface TriageClarificationPayload {
	decline_reason?: string;
	decline_reason_category?: DeclineReason;
	triage_status: TriageStatus;
}

export interface BatchTriagePayload {
	clarification_ids: number[];
	decline_reason?: string;
	decline_reason_category?: DeclineReason;
	triage_status: "accepted" | "declined";
}

export interface DuplicateClarificationPayload {
	duplicate_ids: number[];
	main_clarification_id: number;
}

export interface ApplyToAllPayload {
	clarification_id: number;
}

export interface EditClarificationTextPayload {
	clarification_text: string;
}

export interface StepCompletePayload {
	date_due?: string;
}

export interface ClarificationReviewSummary {
	accepted: number;
	declined: number;
	duplicate: number;
	pending: number;
	reviewed: number;
	total: number;
}

// --- AI Review types ---

export type AISuggestionStatus = "pending" | "accepted" | "dismissed";

export interface AITriageSuggestion {
	clarification_id: number;
	confidence: number;
	reasoning: string;
	suggested_status: TriageStatus;
	text_corrections?: string | null;
}

export interface AIDuplicateGroup {
	confidence: number;
	duplicate_ids: number[];
	reasoning: string;
	suggested_main_id: number;
}

export interface AIReviewSummary {
	focus_areas: string[];
	patterns: string[];
	supplier_counts: Record<string, number>;
	themes: string[];
}

export interface AIReviewResponse {
	duplicates: AIDuplicateGroup[];
	suggestions: AITriageSuggestion[];
	summary: AIReviewSummary;
}
